class StudyPlannerApplication extends PlannerApplication {

    constructor() {
        super("S");
        this.resetSchedule = false;
    }

    loadControllers() {
        super.loadControllers();

        initTimeRangeInputs();
        initHourRangeInputs();
        initMinutesRangeInputs();

        this.controllers.awakeAsleepIndicatorController = new AwakeAsleepIndicatorController();
        this.controllers.dailyRoutineController = new DailyRoutineController();
        this.controllers.familyController = new FamilyController();
        this.controllers.workController = new WorkController();
        this.controllers.commutingController = new CommutingController();
        this.controllers.lifestyleController = new LifestyleController();
        this.controllers.scheduleController = new ScheduleController();
        this.scheduler = new StudyPlannerScheduler();

    }

    createYourProfile() {
        this.studyPlannerProfile = new StudyPlannerYourProfile();
        return this.studyPlannerProfile.getPlannerProfile();
    }

    createAPIService() {
        return new StudyPlannerAPIService(this.config);
    }

    getYourProfile() {
        return this.studyPlannerProfile;
    }

    getUserData(forDebug) {
        if(forDebug) {
            let data = this.studyPlannerProfile.clone();
            data.clearSchedule();
            return data;
        } else {
            return this.studyPlannerProfile;
        }
    }

    createYourProfileFromUserData(userData) {
        this.studyPlannerProfile = new StudyPlannerYourProfile(userData);
        return this.studyPlannerProfile.getPlannerProfile();
    }

    userDataUpdated() {
        super.userDataUpdated();
        if(this.isReady) {
            this.controllers.awakeAsleepIndicatorController.onUpdated();
            if(this.resetSchedule) {
                this.studyPlannerProfile.clearSchedule();
            }
        }
    }

    scheduleUpdated() {
        this.resetSchedule = false;
        this.userDataUpdated();
        this.controllers.scheduleController.summaryController.update(
            this.studyPlannerProfile.getSchedule()
        );
        this.resetSchedule = true;
    }



    restoredYourProfile() {
        super.restoredYourProfile();
        if(this.yourProfile.getCurrentSection() === StudyPlannerSections.scheduler) {
            this.onScheduleSection();
        }
    }

    movedToSection(sectionNo) {
        this.resetSchedule = false;
        super.movedToSection(sectionNo);
        this.resetSchedule = true;
        if(sectionNo === StudyPlannerSections.scheduler) {
            this.onScheduleSection();
        }
    }

    onScheduleSection() {
        if(this.resetSchedule ||
            (this.studyPlannerProfile.getSchedule() === null ||
             this.studyPlannerProfile.getSchedule().getItems().size() === 0)) {
            let schedule = this.scheduler.createSchedule();
            this.studyPlannerProfile.setSchedule(schedule);
        }
        this.controllers.scheduleController.populate(this.studyPlannerProfile.getSchedule());
        this.controllers.scheduleController.helpController.showHelpIfRequired();
    }
}

function createPlannerApp() {
    return new StudyPlannerApplication();
}

